import SvgIcon from '@mui/material/SvgIcon';
import type { SxProps } from "@mui/material";
import React from "react";

export const GroupOfPeople4: React.FC<{ sx?: SxProps }> = ({ sx }) => {
    return (
        <SvgIcon sx={sx}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 93.122 73.846"
            >
                <g>
                    <path
                        d="M363.8,10.7A10.7,10.7,0,1,1,353.1,0a10.7,10.7,0,0,1,10.7,10.7"
                        transform="translate(-306.536)"
                        fill="#e85317"
                    />
                    <path
                        d="M363.8,253.812a10.7,10.7,0,1,1-10.7-10.7,10.7,10.7,0,0,1,10.7,10.7"
                        transform="translate(-306.536 -217.649)"
                        fill="#e85317"
                    />
                    <path
                        d="M306.676,483.015h-.043c-.592-6.32-7.211-11.3-15.29-11.3s-14.7,4.981-15.29,11.3h-.043l-2.566,11.658a1.224,1.224,0,0,0,1.2,1.487h33.407a1.224,1.224,0,0,0,1.2-1.487Z"
                        transform="translate(-244.781 -422.315)"
                        fill="#e85317"
                    />
                    <path
                        d="M637.215,112.921a10.7,10.7,0,1,1-10.7-10.7,10.7,10.7,0,0,1,10.7,10.7"
                        transform="translate(-551.317 -91.513)"
                        fill="#e85317"
                    />
                    <path
                        d="M595.528,355.265H568.758a1.349,1.349,0,0,1-1.292-.973,14.054,14.054,0,0,0-4.44-6.667,1.374,1.374,0,0,1-.452-1.338l.917-4.168h.044c.592-6.32,7.211-11.3,15.29-11.3s14.7,4.982,15.29,11.3h.044l2.566,11.659a1.224,1.224,0,0,1-1.2,1.487"
                        transform="translate(-503.631 -296.174)"
                        fill="#e85317"
                    />
                    <path
                        d="M90.39,112.921a10.7,10.7,0,1,1-10.7-10.7,10.7,10.7,0,0,1,10.7,10.7"
                        transform="translate(-61.757 -91.513)"
                        fill="#e85317"
                    />
                    <path
                        d="M33.728,347.624a14.058,14.058,0,0,0-4.44,6.668,1.349,1.349,0,0,1-1.292.973H1.225a1.225,1.225,0,0,1-1.2-1.487l2.566-11.659h.044c.591-6.32,7.211-11.3,15.29-11.3s14.7,4.982,15.29,11.3h.044l.917,4.167a1.374,1.374,0,0,1-.451,1.338"
                        transform="translate(0 -296.174)"
                        fill="#e85317"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};